import * as Animate from "react-reveal";

const steps = [
  { number: "01", title: "Learn", desc: "Build relevant capability" },
  { number: "02", title: "Prove", desc: "Show practical evidence" },
  { number: "03", title: "Hire", desc: "Connect people and companies" },
  { number: "04", title: "Support", desc: "Manage and pay global teams" },
];

const AboutNextChapterSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Our next chapter
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              The operating system for global talent.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Utiva started by helping people build skills. Today, the platform
              connects upskilling with talent discovery, hiring, management and
              payroll—so opportunity can travel more easily across borders.
            </p>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 rounded-2xl border border-hire-line overflow-hidden">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className={`p-7 ${
                  index !== steps.length - 1
                    ? "border-b sm:border-b-0 lg:border-r border-hire-line"
                    : ""
                }`}
              >
                <span className="text-secondary font-poppins text-xs font-extrabold">
                  {step.number}
                </span>
                <h3 className="font-poppins font-extrabold text-2xl text-primary mt-2 mb-1.5">
                  {step.title}
                </h3>
                <p className="text-gray font-poppins text-sm m-0">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default AboutNextChapterSection;
